import * as React from 'react';
import { useSelector } from 'react-redux';
import { getDeveloper } from '../../selectors/developerV2';
import { trackShowPhone } from '../ContactButtonsRedesigned/tracking';
import { MobileCallButton } from '../../components/MobileCall';
import { getPhoneLabel, getSinglePhone, getSingleSiteBlockId } from './utils/phone';
import { useContacts } from '../Call/useContacts';

const CALL_BUTTON_PLACE_TYPE = 'developerCardContacts';

export function MobileCall() {
  const developer = useSelector(getDeveloper);

  const onShowPhone = React.useCallback((developerId: number) => {
    trackShowPhone('Open_card_builder')(developerId);
  }, []);

  const { builders, sellers } = useContacts();

  const handleShowPhone = React.useCallback(() => {
    onShowPhone(developer.id);
  }, [developer, onShowPhone]);

  const singlePhone = React.useMemo(() => {
    return getSinglePhone(builders, sellers);
  }, [builders, sellers]);
  const singleSiteBlockId = React.useMemo(() => {
    return getSingleSiteBlockId(builders, sellers);
  }, [builders, sellers]);
  const singlePhoneLabel = React.useMemo(() => {
    return getPhoneLabel(builders, sellers);
  }, [sellers, builders]);

  return (
    <MobileCallButton
      onClick={handleShowPhone}
      phone={singlePhone}
      placeType={CALL_BUTTON_PLACE_TYPE}
      buttonText={singlePhoneLabel}
      siteBlockId={singleSiteBlockId}
      size="L"
    />
  );
}
